export default __webpack_public_path__ + "static/assets/7a20c09351d3c573e48388f97c1ac249.svg";